// extracted by mini-css-extract-plugin
export default {"categories":"N8NvQ9","heading":"USZ1rc"};